/**
 * Phase 8 Plan 08-04 — booking cancellation API client.
 *
 * Two endpoints, shared shape for court rentals AND private lessons so the
 * UpcomingEvents cancel modal can branch on bookingType once and the rest
 * of the flow is identical. The lesson backend lands in 08-05; this module
 * is wired now so the UI can call the CR endpoint and reuse for lessons
 * later.
 *
 * Snake_case response fields preserved per project convention (do NOT
 * recase to camelCase).
 */
import api from '../../api'

export type CancelPreviewActive = {
  refund_cents: number
  refund_pct: number
  hours_before_start: number
  tier_applied: string | null
  currency: string
}

export type CancelPreviewAlreadyCancelled = {
  already_cancelled: true
  refund_cents: number
}

export type CancelPreviewClosed = {
  closed: true
  reason: string
}

export type CancelPreviewResponse =
  | CancelPreviewActive
  | CancelPreviewAlreadyCancelled
  | CancelPreviewClosed

export type CancelBookingResponse = {
  refund_cents: number
  refund_pct: number
  tier_applied: string | null
  pi_cancelled: boolean
}

export type BookingType = 'court_rental' | 'lesson'

const previewPath = (type: BookingType, id: string): string =>
  type === 'court_rental'
    ? `court-rentals/${id}/cancel-preview/`
    : `private_classes/private-lessons/bookings/${id}/cancel-preview/`

const cancelPath = (type: BookingType, id: string): string =>
  type === 'court_rental'
    ? `court-rentals/${id}/cancel/`
    : `private_classes/private-lessons/bookings/${id}/cancel/`

export const getCancelPreview = async (
  bookingType: BookingType,
  bookingId: string,
): Promise<CancelPreviewResponse> => {
  const res = await api.get<CancelPreviewResponse>(previewPath(bookingType, bookingId))
  return res.data
}

export const postCancelBooking = async (
  bookingType: BookingType,
  bookingId: string,
): Promise<CancelBookingResponse> => {
  const res = await api.post<CancelBookingResponse>(cancelPath(bookingType, bookingId), {})
  return res.data
}
